

<template>
    <div style="background-color: #0e39bd;height: 100%">

    <div id="table-box">
        <van-row justify="center">
            <!--            <van-col span="6">-->
            <van-image
                width="100%"
                height="100%"
                src="https://afa.activa-leisure.com/img/fkdj.jpg"
            />
            <!--            </van-col>-->
        </van-row>
        <van-col span="20"></van-col>

<!--        <van-form @submit="onSubmit" >-->
        <van-form @submit.prevent="handleSubmit" >
            <van-cell-group inset>
            <van-field
                v-model="fwqy"
                is-link
                label="访问区域"
                @click="isClickFwqy"
                :readonly = "updateReadOnly"
            />
                <van-popup v-model:show="showFwqy" round position="bottom">
                    <van-picker
                        :columns="fwqyColumns"
                        @cancel="showFwqy = false"
                        @confirm="onConfirmFwqy"
                    />
                </van-popup>
                <van-field
                    v-model="name"
                    label="访客姓名"
                    readonly
                    required
                />
                <van-field
                    v-model="tel"
                    type="number"
                    readonly
                    required
                    label="访客电话"
                />
                <van-field
                    v-model="idNo"
                    label="身份证号"
                    maxlength="18"
                    :readonly = "updateReadOnly"
                />
                <van-field
                    v-model="sum"
                    label="随行人数"
                    readonly
                    type="number"
                />
                <van-field
                    v-model="date"
                    label="预约时间"
                    placeholder="请填写预约时间"
                    readonly
                    required
                />
                <van-field
                    v-model="car"
                    readonly
                    label="车辆信息"
                />
                <van-field
                    type="textarea"
                    required
                    readonly
                    v-model="lfsy"
                    label="来访事由"
                />
                <van-field
                    type="textarea"
                    v-model="remark"
                    readonly
                    label="备注"
                />
                <van-field
                    v-model="jdName"
                    required
                    readonly
                    label="接待人姓名"
                />
                <van-field
                    v-model="jdTel"
                    type="number"
                    required
                    readonly
                    label="接待人电话"
                />
                <van-field
                    v-model="jdDept"
                    required
                    readonly
                    label="接待人部门"
                />


                <van-nav-bar title="警卫填写区" />

                <van-field
                    v-model="jwName1"
                    label="警卫姓名"
                    required
                    :rules="[{ required: true, message: '请来访时填写警卫姓名', trigger: 'blur' }]"
                    :readonly = "dfReadOnly"
                    placeholder="请来访时填写警卫姓名"
                />
                <van-field
                v-model="lbNo"
                label="来宾证号"
                type="number"
                maxlength="3"
                required
                :rules="[{ required: true, message: '请填写来宾证号', trigger: 'blur' }]"
                :readonly = "dfReadOnly"
                placeholder="请填写来宾证号"
            />
            <van-field
                v-model="qfNo"
                label="铅封号"
                :readonly = "dfReadOnly"
                placeholder="集卡车请填写铅封号"
            />
            <van-field
                v-model="hgNo"
                label="货柜号"
                :readonly = "dfReadOnly"
                placeholder="集卡车请填写货柜号"
            />

            <van-field
                v-model="dfDate"
                label="到访日期"
                placeholder="请填写实际到访日期"
                readonly
                required
                @click="shouldDfIgnoreClick ? null : (showChoseDfDate = true)"
            />
            <van-field
                type="textarea"
                v-model="dfRemark"
                label="到访备注"
                :readonly = "dfReadOnly"
                placeholder="随行人员，物品清单等"
                />

                <van-field
                    v-model="jwName2"
                    label="警卫姓名"
                    :readonly = "lkReadOnly"
                    :required = "lkRequired"
                    :rules="[{ required: lkRequired, message: '请离开时填写警卫姓名', trigger: 'blur' }]"
                    placeholder="请离开时填写警卫姓名"
                />
            <van-field
                v-model="lkDate"
                label="离开日期"
                placeholder="请填写实际离开日期"
                readonly
                :required = "lkRequired"
                @click="shouldLkIgnoreClick ? null : (showChoseLkDate = true)"
            />
            <van-field
                type="textarea"
                v-model="lkRemark"
                :readonly = "lkReadOnly"
                label="离开备注"
                placeholder="随行人员，物品清单等"
                />




            </van-cell-group>
            <div style="margin: 16px;" >
                <van-button round block type="success" @click="handleSubmit" native-type="submit" style="font-size: larger">
                    提&nbsp;&nbsp;交
                </van-button>
            </div>


            <van-dialog v-model:show="showCaptcha" title="请输入验证码" @confirm="validateCaptcha">
                <!-- 验证码弹出框 -->
                <van-field
                    v-model="captchaCode"
                    label="验证码"
                    type="number"
                    placeholder="验证码"
                />

            </van-dialog>


            <van-popup  v-model:show="showChoseDfDate" round position="bottom">

                <van-picker-group
                    title="到访日期"
                    :tabs="['选择日期', '选择时间']"
                    next-step-text="下一步"
                    @confirm="onDfDateConfirm"
                    @cancel="onDfDateCancel"
                >
                    <van-date-picker
                        v-model="currentDfDate"
                        :min-date="minDate"
                        :max-date="maxDate"
                    />
                    <van-time-picker v-model="currentDfTime" />
                </van-picker-group>
            </van-popup>

            <van-popup  v-model:show="showChoseLkDate" round position="bottom">

                <van-picker-group
                    title="离开日期"
                    :tabs="['选择日期', '选择时间']"
                    next-step-text="下一步"
                    @confirm="onLkDateConfirm"
                    @cancel="onLkDateCancel"
                >
                    <van-date-picker
                        v-model="currentLkDate"
                        :min-date="minDate"
                        :max-date="maxDate"
                    />
                    <van-time-picker v-model="currentLkTime" />
                </van-picker-group>
            </van-popup>



        </van-form>



    </div>
    </div>
</template>

<script setup>
import {ref,onMounted,computed  } from "vue";
import {useRoute} from 'vue-router';
import axios from "axios";

const fwqy = ref('');
const showFwqy = ref(false);
const isClickFwqy = () => {
    if(jwName2.value == null || jwName2.value != ""){
        showFwqy.value = false
    }else {
        showFwqy.value = true
    }
}
let fwqyColumns = [
    { text: '一期厂区', value: '1' },
    { text: '二期厂区', value: '2' },
    { text: '行政楼', value: '3' },
    { text: '生活区', value: '4' },
];
const onConfirmFwqy = ({ selectedOptions }) => {
    showFwqy.value = false;
    fwqy.value = selectedOptions[0].text;
};
const name = ref('');
const tel = ref('');
const idNo = ref('');
const sum = ref('');
const date = ref('');
const car = ref('');
const lfsy = ref('');
const remark = ref('');
const jdName = ref('');
const jdTel = ref('');
const jdDept = ref('');

const route = useRoute();
const id = computed(() => route.params.id);
const lbNo = ref('');
const hgNo = ref('');
const qfNo = ref('');
const dfDate = ref('');
const lkDate = ref('');
const showChoseDfDate = ref(false);
const showChoseLkDate = ref(false);

const currentDfDate = ref(['2022', '06', '01']);
const currentLkDate = ref(['2022', '06', '01']);
const currentDfTime = ref(['12', '00']);
const currentLkTime = ref(['12', '00']);
const minDate = new Date(2020, 0, 1);
const maxDate = new Date(2099, 1, 1);

const dfRemark = ref('');
const lkRemark = ref('');
const jwName1 = ref('');
const jwName2 = ref('');

const lkRequired = ref(true);
const lkReadOnly = ref(false);
const dfReadOnly = ref(false);

const updateReadOnly = ref(false);

const shouldLkIgnoreClick = ref(false);
const shouldDfIgnoreClick = ref(false);

const showCaptcha = ref(false);
const captchaCode = ref('');
const correctCaptcha = ref('1234');


const onDfDateConfirm = () => {
    dfDate.value=`${currentDfDate.value.join('/')} ${currentDfTime.value.join(':')}`;
    showChoseDfDate.value=false;
};
const onLkDateConfirm = () => {
    lkDate.value=`${currentLkDate.value.join('/')} ${currentLkTime.value.join(':')}`;
    showChoseLkDate.value=false;
};
const onDfDateCancel = () => {
    showChoseDfDate.value=false;
    dfDate.value='';
};
const onLkDateCancel = () => {
    showChoseLkDate.value=false;
    lkDate.value='';
};

const validateCaptcha = () => {
    if (captchaCode.value == correctCaptcha.value) {
        onSubmit();
    }else {
        alert("验证码错误");
    }
    return '验证码错误';
};

onMounted(() => {
    window.document.title = '宁波万汇访客登记';
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0'); // 月份从0开始，所以需要+1，并填充前导零
    const day = String(now.getDate()).padStart(2, '0'); // 填充前导零
    const hours = now.getHours();
    const minutes = now.getMinutes();
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

    correctCaptcha.value = day+month;

    currentDfDate.value = [year, month, day];
    currentDfTime.value = [hours, formattedMinutes];
    dfDate.value=`${currentDfDate.value.join('/')} ${currentDfTime.value.join(':')}`;
    lkDate.value=`${currentDfDate.value.join('/')} ${currentDfTime.value.join(':')}`;


    // 发送GET请求
    axios.get(process.env.VUE_APP_API_BASE_URL+"/lj/fkdj/detail/"+id.value,
        {},
        {
            headers:{
                "content-type": "application/x-www-form-urlencoded"
            }
        }
    ).then( response =>{
            // 处理响应数据
            console.log(response.data.message);
            fwqy .value = response.data.message.fwqy;
            name.value = response.data.message.name;
            tel.value = response.data.message.tel;
            idNo.value = response.data.message.idNo;
            sum.value = response.data.message.sum;
            date.value = response.data.message.strCheckInDate;
            car.value = response.data.message.car;
            lfsy.value = response.data.message.lfsy;
            remark.value = response.data.message.remark;
            jdName.value = response.data.message.jdName;
            jdTel.value = response.data.message.jdTel;
            jdDept.value = response.data.message.jdDept;

            //来访登记时，俩时间都是空
            if (response.data.message.strRealDate1 == null & response.data.message.strRealDate2 == null){
                alert("开始来访登记")
                lkDate.value = '';

                lkRequired.value = false;
                lkReadOnly.value = true;
                shouldLkIgnoreClick.value = true;
                shouldDfIgnoreClick.value = false;
            }

            //离开登记时，来访时间不为空，离开时间为空
            if (response.data.message.strRealDate1 != null & response.data.message.strRealDate2 == null){
                alert("开始离开登记")
                shouldLkIgnoreClick.value = false;
                shouldDfIgnoreClick.value = true;
                dfReadOnly.value = true;

                dfDate.value = response.data.message.strRealDate1;
                dfRemark.value = response.data.message.remark1;
                lbNo.value = response.data.message.lbNo;
                hgNo.value = response.data.message.hgNo;
                qfNo.value = response.data.message.qfNo;
                jwName1.value = response.data.message.jwName1;
            }

            //如果都不为空
            if (response.data.message.strRealDate1 != null & response.data.message.strRealDate2 != null){
                alert("访客登记已结束")
                lbNo.value = response.data.message.lbNo;
                hgNo.value = response.data.message.hgNo;
                qfNo.value = response.data.message.qfNo;
                dfDate.value = response.data.message.strRealDate1;
                dfRemark.value = response.data.message.remark1;
                jwName1.value = response.data.message.jwName1;

                lkDate.value = response.data.message.strRealDate2;
                lkRemark.value = response.data.message.remark2;
                jwName2.value = response.data.message.jwName2;

                shouldLkIgnoreClick.value = true;
                shouldDfIgnoreClick.value = true;
                lkReadOnly.value = true;
                dfReadOnly.value = true;

                updateReadOnly.value = true;

            }



        }).catch(error => {
        if (error.response) {
            // 服务器响应了一个状态码，范围在2xx之外
            console.log('Error Response:', error.response.data);
            console.log('Error Status:', error.response.status);
            console.log('Error Headers:', error.response.headers);
        } else if (error.request) {
            // 请求已经发出，但没有收到响应
            console.log('Error Request:', error.request);
        } else {
            // 其他错误
            console.log('Error Message:', error.message);
        }
        console.log('Error Config:', error.config);
    });

})

const handleSubmit  = () => {
    showCaptcha.value = true;
}

const onSubmit  = () => {

    const formData = {
        /*
        name:name.value,
        tel:tel.value,
        sum:sum.value,
        date:date.value,
        car:car.value,
        lfsy:lfsy.value,
        remark:remark.value,
        jdName:jdName.value,
        jdTel:jdTel.value,
        jdDept:jdDept.value*/
        id:id.value,
        fwqy:fwqy.value,
        idNo:idNo.value,
        lbNo:lbNo.value,
        hgNo:hgNo.value,
        qfNo:qfNo.value,
        dfDate:dfDate.value,
        dfRemark:dfRemark.value,
        jwName1:jwName1.value,
        lkDate:lkDate.value,
        lkRemark:lkRemark.value,
        jwName2:jwName2.value
    }

    if(dfDate.value.length != 0){
        if(jwName1.value==null || jwName1.value==""){
            alert("警卫姓名不能为空！")
            return
        }
        if(lbNo.value==null || lbNo.value==""){
            alert("来宾证号不能为空！")
            return
        }
    }
    if(lkDate.value.length != 0){
        if(jwName2.value==null || jwName2.value==""){
            alert("警卫姓名不能为空！")
            return
        }
    }

    axios.post(process.env.VUE_APP_API_BASE_URL + '/lj/fkdj/submit/df', formData,{
        headers: {
            'Content-Type': 'application/json'
        }
    })
        .then(response => {
            console.log('提交成功:', response.data)
            // 在这里可以根据后台返回的数据进行相应的处理
            alert(response.data.message)
        })
        .catch(error => {
            if (error.response) {
                // 请求已经发出，但服务器返回状态码不在2xx范围内
                console.error('返回失败:', error.response.const)
            } else {
                // 请求未能发出
                alert('提交失败:' + error.message)
                console.error('提交失败:', error.message)
            }
        })

}


</script>

<style scoped>


.body_qr {
    text-align: center;
}

</style>
